import * as React from 'react';
import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import {getTargetName} from '../utils/Utils';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import SuccessSendModalView from '../../../../common/components/SuccessSendModalView';
import {AnyAction, Dispatch} from 'redux';
import {
    ModalContainerDispatchProps
} from '../types/containers';

const mapStateToProps = (state: State, ownProps) => {
    const data = ownProps.data || null;
    const target: string = !!data ? data.target : null;
    return {
        mainText: 'Enviando archivo...',
        subText: `Se está enviando el archivo a ${getTargetName(target)}`,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): ModalContainerDispatchProps => {
    return {
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const SendAttachmentsSuccessTargetContainer = connect(mapStateToProps, mapDispatchToProps)(SuccessSendModalView);

export default SendAttachmentsSuccessTargetContainer;